module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"plan":"Ваш тарифный план","active":"Активен","disabled":"Неактивен","left":"Ваш баланс","currentPeriod":"Текущий период","payedUntil":"Оплачен до","subscriptionExpired":"Подписка закончилась","change":"Изменить"}}')
  delete Component.options._Ctor
}
